import { all, call, getContext, takeLatest } from 'redux-saga/effects';

import { sseAccessToken } from './types';

export function* requestSseAccessTokenSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.platform.events_access_token'),
    );

    yield action.resolve(response.data);
  } catch (error) {
    yield action.reject();
  }
}

export default function* activitiesSaga() {
  return yield all([takeLatest(sseAccessToken.request, requestSseAccessTokenSaga)]);
}
